/**
 * /chat/:sessionId 라우트 — 기존 세션 대화
 *
 * AgentLayout + ChatZone (sessionId prop 전달)
 */

import { createFileRoute } from "@tanstack/react-router";
import { AgentLayout } from "@/agent/layouts/agent-layout";
import { ChatZone } from "@/agent/features/chat/chat-zone";
import { Suspense } from "react";
import { ChatSkeleton } from "@/agent/ui/errors/skeleton-fallback";
import "@/agent/widgets/register-all";

export const Route = createFileRoute("/_protected/chat_/$sessionId")({
  beforeLoad: () => ({
    layoutMode: "agent-first" as const,
  }),
  component: ChatSessionPage,
});

function ChatSessionPage() {
  const { sessionId } = Route.useParams();

  return (
    <AgentLayout initialMode="agent-first">
      <Suspense fallback={<ChatSkeleton className="flex-1" />}>
        {/* key={sessionId}로 강제 remount — route 전환 시 useAgentChat state 및
            useChatHydration 쿼리가 fresh하게 초기화되어 정상 fetch & hydrate.
            useState(initial)이 prop 변경을 감지하지 못하는 React 특성 회피. */}
        <ChatZone key={sessionId} sessionId={sessionId} />
      </Suspense>
    </AgentLayout>
  );
}
